import {createAction, props} from '@ngrx/store';
import {getApiActionsForGivenModule, getApiActionsWithRequestedPayloadForGivenModule} from 'amc-common-components';
import {ItemCommon} from '@entities/common/common.interface';
import {StoreModules} from '@shared/enums/store';
import {getModuleActionName} from '@shared/helpers/store/actions.helper';
import {Payload} from '@shared/interfaces/store.interfaces';
import {
	CtsEditModalData,
	CtsEditModalParams,
	CtsEditPeriodData,
	CtsSavedRows,
	CtsSorting,
	CtsTableDataWithPagination,
	CtsTableFilters,
	CtsTableRow,
} from '@entities/cts-distribution/cts-distribution.interfaces';
import {Moment} from 'moment/moment';

/**
 * Auxiliary Module name variable for creating unique actions.
 */
const moduleName = StoreModules.CtsDistribution;
/**
 * Auxiliary function for get the module action name.
 */
const createActionName = getModuleActionName(moduleName);
/**
 * Auxiliary variable for creating actions to load data with payload.
 */
const getApiActionWithRequestedPayload = getApiActionsWithRequestedPayloadForGivenModule(moduleName);
/**
 * Auxiliary variable for creating actions to load data.
 */
const getApiActions = getApiActionsForGivenModule(moduleName);

/**
 * Auxiliary variable with declaration type of actions for CTS Distribution Actions Page.
 */
const types = {
	getTableData: createActionName('Get table data'),
	getPlatformFilter: createActionName('Get Platform Filter'),
	getPeriodFilter: createActionName('Get Period Filter'),
	getProgramTypeFilter: createActionName('Get Program Type Filter'),
	saveRows: createActionName('Save Rows'),
	getTableXLS: createActionName('Get Table XLS'),
	getPagesCount: createActionName('Get pages count'),
	selectPage: createActionName('Select Page'),
	updateTableRows: createActionName('Update Table Rows'),
	setTableFilters: createActionName('Set Table Filters'),
	setTableSorting: createActionName('Set Table Sorting'),
	setHistoricalDate: createActionName('Set Historical Date'),
	openEditModal: createActionName('Open Edit Modal'),
	resetState: createActionName('Reset state'),
};

/**
 * Auxiliary export declaration actions for CTS Distribution Actions Page.
 */
export const ctsDistributionActions = {
	getTableData: getApiActionWithRequestedPayload(
		types.getTableData,
		props<Payload<unknown>>(),
		props<Payload<CtsTableDataWithPagination>>()
	),
	getPlatformFilter: getApiActionWithRequestedPayload(
		types.getPlatformFilter,
		props<Payload<unknown>>(),
		props<Payload<ItemCommon[]>>()
	),
	getPeriodFilter: getApiActionWithRequestedPayload(
		types.getPeriodFilter,
		props<Payload<unknown>>(),
		props<Payload<CtsEditPeriodData>>()
	),
	getProgramTypeFilter: getApiActionWithRequestedPayload(
		types.getProgramTypeFilter,
		props<Payload<unknown>>(),
		props<Payload<ItemCommon[]>>()
	),
	saveRows: getApiActionWithRequestedPayload(
		types.saveRows,
		props<Payload<CtsEditModalParams>>(),
		props<Payload<CtsSavedRows>>()
	),
	getPagesCount: getApiActions(types.getPagesCount, props<Payload<number>>()),
	selectPage: createAction(types.selectPage, props<Payload<number>>()),
	updateTableRows: createAction(types.updateTableRows, props<Payload<CtsTableRow[]>>()),
	setTableFilters: createAction(types.setTableFilters, props<Payload<CtsTableFilters>>()),
	setTableSorting: createAction(types.setTableSorting, props<Payload<CtsSorting>>()),
	setHistoricalDate: createAction(types.setHistoricalDate, props<Payload<Moment>>()),
	openEditModal: createAction(types.openEditModal, props<Payload<CtsEditModalData>>()),
	resetState: createAction(types.resetState),
};
